import { BuyShippingModelType } from '@teinor/erp/types/company/order/buy/buyShipping'
import ITHeaderText from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormElement, FormRender } from '../../../../../../../forms/FormRenderer/types'
import useBuyTypeShippingDict from '../../../../../../../utils/hooks/buys/useBuyTypeShipping'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import { GroupVatPayload } from '../../../../../../../utils/reducers/globals/groupVats'
import '../buyHeader.sass'

interface BuyReadOnlyHeaderShippingProps extends InputTableLeftTabsProps {
    groupVats: GroupVatPayload
}

const BuyReadOnlyHeaderShipping: React.FC<BuyReadOnlyHeaderShippingProps> = ({ headerData, handleChange, groupVats }) => {
    const { t } = useTwinTranslation()
    const shipping = headerData?.OrderShipping
    const dictTypeShipping = useBuyTypeShippingDict()
    const extraElements: FormElement<keyof BuyShippingModelType>[] = []

    if (shipping) {
           extraElements.push(
               {
                   name: 'priceVatIncluded',
                   component: 'CheckboxMargin',
                   label: t('priceWithVat', 'Precio con iva'),
                   checked: headerData?.OrderShipping?.priceVatIncluded,
                   className: returnClassOfSpanTemplate(5)
               }
           )
        const fieldPrice = shipping?.priceVatIncluded ? 'finalPriceWithTax' : 'initialPriceWithoutTax'
        extraElements.push(
            {
                name: fieldPrice, 
                component: 'Custom',
                render: () => <ITHeaderText label={t('priceShipping', 'Precio transporte')} value={headerData?.OrderShipping?.[fieldPrice]} className={returnClassOfSpanTemplate(5)} />,
            },
            {
                name: 'trackingId',
                component: 'Custom',
                render: () => <ITHeaderText label={t('trackingNumber', 'N. seguimiento')} value={shipping?.trackingId||'-'} className={returnClassOfSpanTemplate(5)} />
            },
            {
                name: 'GroupVatId',
                component: 'Custom',
                render: () => <ITHeaderText label={t('vats', 'Impuestos')} value={groupVats?.[shipping?.GroupVatId]?.name || '-'} className={returnClassOfSpanTemplate(5)} />
            },
        )
    }
    const sections: FormRender<BuyShippingModelType> = [
        {
            cols: 5,
            elements: [
                {
                    name: 'type',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('typeShipping', 'Tipo de envío')} value={dictTypeShipping[headerData.typeShipping]?.name || ''} className={returnClassOfSpanTemplate(5)} />
                },
                ...extraElements
            ]
        }
    ]

    return (
        <InputTableLeftColumnForm form={sections} headerData={headerData} handleChange={handleChange} />
    )
}

export default BuyReadOnlyHeaderShipping